export default __webpack_public_path__ + "static/media/football.33e08166.png";